function toggleMenu() {
  const menuDrawer = document.getElementById('menu-drawer');
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  // Close cart if open
  if (cartDrawer && !cartDrawer.classList.contains('translate-x-full')) {
    cartDrawer.classList.add('translate-x-full');
  }

  if (menuDrawer.classList.contains('-translate-x-full')) {
    menuDrawer.classList.remove('-translate-x-full');
    overlay.classList.remove('hidden');
  } else {
    menuDrawer.classList.add('-translate-x-full');
    // Only hide overlay if cart is also closed (which it should be, but safety first)
    if (!cartDrawer || cartDrawer.classList.contains('translate-x-full')) {
      overlay.classList.add('hidden');
    }
  }
}

function toggleCart() {
  const cartDrawer = document.getElementById('cart-drawer');
  const menuDrawer = document.getElementById('menu-drawer');
  const overlay = document.getElementById('overlay');

  // Close menu if open
  if (menuDrawer && !menuDrawer.classList.contains('-translate-x-full')) {
    menuDrawer.classList.add('-translate-x-full');
  }

  if (cartDrawer.classList.contains('translate-x-full')) {
    cartDrawer.classList.remove('translate-x-full');
    overlay.classList.remove('hidden');
  } else {
    cartDrawer.classList.add('translate-x-full');
    // Only hide overlay if menu is also closed
    if (!menuDrawer || menuDrawer.classList.contains('-translate-x-full')) {
      overlay.classList.add('hidden');
    }
  }
}

function closeAllDrawers() {
  const menuDrawer = document.getElementById('menu-drawer');
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  if (menuDrawer) menuDrawer.classList.add('-translate-x-full');
  if (cartDrawer) cartDrawer.classList.add('translate-x-full');
  if (overlay) overlay.classList.add('hidden');
}

// Global helper to save preference when buttons are clicked (called from inline onclick)
window.saveLanguagePreference = function (isoCode) {
  localStorage.setItem('sindrome_user_lang', isoCode);
}

function toggleAccordion(id) {
  const el = document.getElementById(id);
  if (!el) return;

  // Toggle Tailwind classes for accordion effect
  // We use classList checks to swap simple state
  if (el.classList.contains('max-h-0')) {
    el.classList.remove('max-h-0', 'opacity-0');
    el.classList.add('max-h-96', 'opacity-100');
  } else {
    el.classList.add('max-h-0', 'opacity-0');
    el.classList.remove('max-h-96', 'opacity-100');
  }
}
// Load cart items
function loadCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItems = document.getElementById('cart-items');
      const cartCount = document.getElementById('cart-count');
      
      cartCount.textContent = cart.item_count;
      
      if (cart.items.length === 0) {
      cartItems.innerHTML = '<div style="height: 300px; display: flex; align-items: center; justify-content: center;"><p class="text-sm">Il carrello è vuoto come la tua anima...</p></div>';



        return;
      }
      
      let html = '';
      cart.items.forEach(item => {
        html += `
                    <div class="border-b border-black py-4">
            <div class="flex gap-4 w-full overflow-hidden">
              <img src="${item.image}" alt="${item.title}" class="w-20 h-20 object-cover">
              <div class="flex-1 min-w-0">
                <h3 class="font-condensed uppercase text-sm" style="white-space:normal;word-break:break-word;">${item.product_title}</h3>
                <p class="text-xs">${item.variant_title}</p>
                <p class="text-xs mt-2">Quantità: ${item.quantity}</p>
                <p class="text-xs font-bold">${(item.price / 100).toFixed(2)} €</p>
              </div>
            </div>
          </div>
        `;
});

      
      html += `
        <div class="mt-4 pt-4 border-t border-black">
          <div class="flex justify-between font-bold mb-4">
            <span>TOTALE:</span>
            <span>${(cart.total_price / 100).toFixed(2)} €</span>
          </div>
          <a href="/checkout" class="block w-full bg-black text-white text-center py-3 uppercase text-sm tracking-widest hover:bg-gray-800">
            Checkout
          </a>
        </div>
      `;
      
      cartItems.innerHTML = html;
    });
}

// Load cart when drawer opens
const originalToggleCart = toggleCart;
toggleCart = function() {
  originalToggleCart();
  loadCart();
};
